import React, { useState } from 'react';
import BudgetSummary from './budgetSummary';

const Bottom = () => {
  const [activeTab, setActiveTab] = useState('overview');

  // Income & Spending Data
  const incomeSpendingData = [
    { month: 'Previous Balance', income: '₹ 500.00', spending: '', amountLeft: '', spendingRate: '', savingRate: 'base on % allocated to Savings', isBalance: true },
    { month: 'March 2023', income: '₹ 5,350.00', spending: '₹ 5,131.00', amountLeft: '₹ 719.00', spendingRate: '77%', savingRate: '23%', highlight: 'green' },
    { month: 'April 2023', income: '₹ 6,350.00', spending: '₹ 4,460.00', amountLeft: '₹ 2,609.00', spendingRate: '78%', savingRate: '22%' },
    { month: 'May 2023', income: '₹ 6,400.00', spending: '₹ 5,835.00', amountLeft: '₹ 1,774.00', spendingRate: '68%', savingRate: '32%' },
    { month: 'June 2023', income: '₹ 6,350.00', spending: '₹ 6,540.00', amountLeft: '₹ 2,984.00', spendingRate: '66%', savingRate: '34%', highlight: 'red' },
    { month: 'July 2023', income: '₹ 6,350.00', spending: '₹ 6,517.00', amountLeft: '₹ 2,817.00', spendingRate: '62%', savingRate: '38%', highlight: 'green' },
    { month: 'August 2023', income: '₹ 6,350.00', spending: '₹ 4,467.00', amountLeft: '₹ 4,700.00', spendingRate: '83%', savingRate: '17%' },
    { month: 'September 2023', income: '₹ 6,400.00', spending: '₹ 5,835.00', amountLeft: '₹ 5,265.00', spendingRate: '74%', savingRate: '26%', highlight: 'red' },
    { month: 'October 2023', income: '₹ 5,850.00', spending: '₹ 3,040.00', amountLeft: '₹ 8,075.00', spendingRate: '33%', savingRate: '7%', highlight: 'green' },
    { month: 'November 2023', income: '₹ 0.00', spending: '₹ 0.00', amountLeft: '₹ 8,075.00', spendingRate: '0%', savingRate: '0%' },
    { month: 'December 2023', income: '₹ 0.00', spending: '₹ 0.00', amountLeft: '₹ 8,075.00', spendingRate: '0%', savingRate: '0%' },
    { month: 'January 2024', income: '₹ 5,850.00', spending: '₹ 4,920.25', amountLeft: '₹ 9,004.75', spendingRate: '89%', savingRate: '11%' },
    { month: 'February 2024', income: '₹ 5,350.00', spending: '₹ 4,763.00', amountLeft: '₹ 9,591.75', spendingRate: '91%', savingRate: '9%', highlight: 'red' },
    { month: 'Total', income: '₹ 61,100.00', spending: '₹ 51,508.25', amountLeft: '₹ 9,591.75', spendingRate: '66%', savingRate: '34%', isTotal: true }
  ];

  // Expenses Data
  const expensesData = [
    { month: 'March 2023', budget: '₹ 2600.00', actual: '₹ 2,810.00', remaining: '₹ 0.00', excess: '₹ 210.00', rank: '2' },
    { month: 'April 2023', budget: '₹ 2,600.00', actual: '₹ 2,600.00', remaining: '₹ 0.00', excess: '₹ 0.00', rank: '3' },
    { month: 'May 2023', budget: '₹ 2,750.00', actual: '₹ 2,600.00', remaining: '₹ 150.00', excess: '₹ 0.00', rank: '4' },
    { month: 'June 2023', budget: '₹ 4,000.00', actual: '₹ 2,930.00', remaining: '₹ 1,070.00', excess: '₹ 0.00', rank: '1', highlight: 'red' },
    { month: 'July 2023', budget: '₹ 3,100.00', actual: '₹ 2,600.00', remaining: '₹ 500.00', excess: '₹ 0.00', rank: '5' },
    { month: 'August 2023', budget: '₹ 3,250.00', actual: '₹ 2,600.00', remaining: '₹ 650.00', excess: '₹ 0.00', rank: '6' },
    { month: 'September 2023', budget: '₹ 3,100.00', actual: '₹ 2,600.00', remaining: '₹ 500.00', excess: '₹ 0.00', rank: '7' },
    { month: 'October 2023', budget: '₹ 4,300.00', actual: '₹ 2,230.00', remaining: '₹ 2,070.00', excess: '₹ 0.00', rank: '10', highlight: 'green' },
    { month: 'November 2023', budget: '₹ 3,250.00', actual: '₹ 0.00', remaining: '₹ 3,250.00', excess: '₹ 0.00', rank: '' },
    { month: 'December 2023', budget: '₹ 3,100.00', actual: '₹ 0.00', remaining: '₹ 3,100.00', excess: '₹ 0.00', rank: '' },
    { month: 'January 2024', budget: '₹ 3,100.00', actual: '₹ 2,530.25', remaining: '₹ 569.75', excess: '₹ 0.00', rank: '8' },
    { month: 'February 2024', budget: '₹ 3,550.00', actual: '₹ 2,525.00', remaining: '₹ 1,025.00', excess: '₹ 0.00', rank: '9' },
    { month: 'Total', budget: '₹ 38,700.00', actual: '₹ 26,025.25', remaining: '₹ 12,674.75', excess: '₹ 0.00', rank: '', isTotal: true }
  ];

  // Debts Data
  const debtsData = [
    { month: 'March 2023', goal: '₹ 800.00', actual: '₹ 900.00', remaining: '₹ 0.00', excess: '₹ 100.00', rank: '1', highlight: 'red' },
    { month: 'April 2023', goal: '₹ 800.00', actual: '₹ 300.00', remaining: '₹ 500.00', excess: '₹ 0.00', rank: '4' },
    { month: 'May 2023', goal: '₹ 800.00', actual: '₹ 300.00', remaining: '₹ 500.00', excess: '₹ 0.00', rank: '5', highlight: 'green' },
    { month: 'June 2023', goal: '₹ 300.00', actual: '₹ 300.00', remaining: '₹ 0.00', excess: '₹ 0.00', rank: '6', highlight: 'green' },
    { month: 'July 2023', goal: '₹ 800.00', actual: '₹ 300.00', remaining: '₹ 500.00', excess: '₹ 0.00', rank: '7', highlight: 'green' },
    { month: 'August 2023', goal: '₹ 300.00', actual: '₹ 300.00', remaining: '₹ 0.00', excess: '₹ 0.00', rank: '8', highlight: 'green' },
    { month: 'September 2023', goal: '₹ 300.00', actual: '₹ 300.00', remaining: '₹ 0.00', excess: '₹ 0.00', rank: '9', highlight: 'green' },
    { month: 'October 2023', goal: '₹ 300.00', actual: '₹ 0.00', remaining: '₹ 300.00', excess: '₹ 0.00', rank: '' },
    { month: 'November 2023', goal: '₹ 300.00', actual: '₹ 0.00', remaining: '₹ 300.00', excess: '₹ 0.00', rank: '' },
    { month: 'December 2023', goal: '₹ 300.00', actual: '₹ 0.00', remaining: '₹ 300.00', excess: '₹ 0.00', rank: '' },
    { month: 'January 2024', goal: '₹ 300.00', actual: '₹ 800.00', remaining: '₹ 0.00', excess: '₹ 500.00', rank: '2' },
    { month: 'February 2024', goal: '₹ 300.00', actual: '₹ 800.00', remaining: '₹ 0.00', excess: '₹ 500.00', rank: '3' },
    { month: 'Total', goal: '₹ 5,600.00', actual: '₹ 4,300.00', remaining: '₹ 1,300.00', excess: '₹ 0.00', rank: '', isTotal: true }
  ];

  const styles = `
    .annualView-bottom-dashboard-container {
    width:100%,
    //   min-height: 100vh;
      background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
      padding: 24px;
      font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
    }

    .main-wrapper {
    //   max-width: 1400px;
    width:100%,
      margin: 0 auto;
    }

    .header-section {
      margin-bottom: 32px;
      text-align: center;
      padding: 24px;
      background: white;
      border-radius: 16px;
      box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
    }

    .main-title {
      font-size: 2.5rem;
      font-weight: 700;
      color: #2d3748;
      margin-bottom: 8px;
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 16px;
    }

    .subtitle {
      color: #718096;
      font-size: 1.1rem;
    }

    .tabs-container {
      display: flex;
      gap: 8px;
      margin-bottom: 24px;
      justify-content: center;
    }

    .tab-button {
      padding: 12px 24px;
      font-size: 14px;
      font-weight: 600;
      border-radius: 8px;
      border: none;
      cursor: pointer;
      transition: all 0.3s ease;
      position: relative;
      overflow: hidden;
    }

    .tab-button.active {
      background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
      color: white;
      box-shadow: 0 4px 15px rgba(102, 126, 234, 0.4);
      transform: translateY(-2px);
    }

    .tab-button.inactive {
      background: white;
      color: #4a5568;
      border: 2px solid #e2e8f0;
    }

    .tab-button.inactive:hover {
      background: #f7fafc;
      border-color: #cbd5e0;
      transform: translateY(-1px);
    }

    .table-container {
      background: white;
      border-radius: 12px;
      box-shadow: 0 10px 40px rgba(0, 0, 0, 0.1);
      overflow: hidden;
      margin-bottom: 24px;
    }

    .table-header {
      padding: 20px 24px;
      color: white;
      font-weight: 700;
      font-size: 1.25rem;
      display: flex;
      align-items: center;
      gap: 12px;
    }

    .income-header {
      background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    }

    .expenses-header {
      background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);
    }

    .debts-header {
      background: linear-gradient(135deg, #4facfe 0%, #00f2fe 100%);
    }

    .data-table {
      width: 100%;
      border-collapse: collapse;
    }

    .table-head {
      background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
    }

    .table-head th {
      padding: 16px 12px;
      font-weight: 600;
      color: #495057;
      text-align: center;
      border-bottom: 2px solid #dee2e6;
    }

    .table-head th:first-child {
      text-align: left;
    }

    .table-row {
      transition: all 0.2s ease;
    }

    .table-row:hover {
      background: rgba(102, 126, 234, 0.05);
      transform: scale(1.002);
    }

    .table-row.balance-row {
      background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
    }

    .table-row.total-row {
      background: linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%);
      border-top: 3px solid #2196f3;
      font-weight: 600;
    }

    .table-cell {
      padding: 14px 12px;
      text-align: center;
      border-bottom: 1px solid #e9ecef;
      color: #495057;
    }

    .table-cell:first-child {
      text-align: left;
      font-weight: 600;
    }

    .table-cell.green-text {
      color: #28a745;
      font-weight: 600;
    }

    .table-cell.red-text {
      color: #dc3545;
      font-weight: 600;
    }

    .table-cell.balance-text {
      color: #6c757d;
      font-size: 0.85rem;
    }

    .two-table-grid {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 24px;
    }

    .small-table {
      font-size: 0.9rem;
    }

    .small-table .table-cell {
      padding: 10px 8px;
    }

    .coming-soon {
      background: white;
      border-radius: 12px;
      box-shadow: 0 10px 40px rgba(0, 0, 0, 0.1);
      padding: 48px;
      text-align: center;
    }

    .coming-soon-icon {
      font-size: 4rem;
      color: #cbd5e0;
      margin-bottom: 16px;
    }

    .coming-soon-title {
      font-size: 1.8rem;
      font-weight: 700;
      color: #2d3748;
      margin-bottom: 8px;
    }

    .coming-soon-text {
      color: #718096;
      font-size: 1.1rem;
    }

    .month-cell {
      display: flex;
      align-items: center;
      gap: 8px;
    }

    .icon-calendar {
      color: #6c757d;
    }

    @media (max-width: 768px) {
      .two-table-grid {
        grid-template-columns: 1fr;
      }
      
      .main-title {
        font-size: 2rem;
        flex-direction: column;
        gap: 8px;
      }
      
      .tabs-container {
        flex-direction: column;
        align-items: center;
      }
      
      .tab-button {
        width: 200px;
      }
    }
  `;

  const TabButton = ({ id, label, isActive, onClick }) => (
    <button
      className={`tab-button ${isActive ? 'active' : 'inactive'}`}
      onClick={() => onClick(id)}
    >
      {label}
    </button>
  );

  const IncomeSpendingTable = () => (
    <div className="table-container">
      <div className="table-header income-header">
        <i className="fa fa-chart-line"></i>
        SUMMARY Income & Spending
      </div>
      <div style={{ overflowX: 'auto' }}>
        <table className="data-table">
          <thead className="table-head">
            <tr>
              <th>Month</th>
              <th>Income</th>
              <th>Spending</th>
              <th>Amount Left</th>
              <th>Spending Rate</th>
              <th>Saving Rate</th>
            </tr>
          </thead>
          <tbody>
            {incomeSpendingData.map((row, index) => (
              <tr key={index} className={`table-row ${
                row.isBalance ? 'balance-row' : 
                row.isTotal ? 'total-row' : ''
              }`}>
                <td className="table-cell">
                  <div className="month-cell">
                    <i className="fa fa-calendar icon-calendar"></i>
                    {row.month}
                  </div>
                </td>
                <td className={`table-cell ${
                  row.highlight === 'green' ? 'green-text' : 
                  row.highlight === 'red' ? 'red-text' : ''
                }`}>
                  {row.income}
                </td>
                <td className={`table-cell ${
                  row.highlight === 'red' ? 'red-text' : ''
                }`}>
                  {row.spending}
                </td>
                <td className="table-cell">{row.amountLeft}</td>
                <td className={`table-cell ${
                  row.highlight === 'green' ? 'green-text' : ''
                }`}>
                  {row.spendingRate}
                </td>
                <td className={`table-cell ${
                  row.isBalance ? 'balance-text' : 
                  row.highlight === 'green' ? 'green-text' : ''
                }`}>
                  {row.savingRate}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );

  const ExpensesDebtsTable = () => (
    <div className="two-table-grid">
      {/* Expenses Table */}
      <div className="table-container">
        <div className="table-header expenses-header">
          <i className="fa fa-money"></i>
          EXPENSES
        </div>
        <div style={{ overflowX: 'auto' }}>
          <table className="data-table small-table">
            <thead className="table-head">
              <tr>
                <th>Month</th>
                <th>Budget</th>
                <th>Actual</th>
                <th>Remaining</th>
                <th>Excess</th>
                <th>Rank</th>
              </tr>
            </thead>
            <tbody>
              {expensesData.map((row, index) => (
                <tr key={index} className={`table-row ${
                  row.isTotal ? 'total-row' : ''
                }`}>
                  <td className="table-cell">
                    <div className="month-cell">
                      <i className="fa fa-calendar icon-calendar"></i>
                      {row.month}
                    </div>
                  </td>
                  <td className="table-cell">{row.budget}</td>
                  <td className={`table-cell ${
                    row.highlight === 'red' ? 'red-text' : 
                    row.highlight === 'green' ? 'green-text' : ''
                  }`}>
                    {row.actual}
                  </td>
                  <td className="table-cell">{row.remaining}</td>
                  <td className="table-cell">{row.excess}</td>
                  <td className="table-cell" style={{ fontWeight: 'bold' }}>
                    {row.rank}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {/* Debts Table */}
      <div className="table-container">
        <div className="table-header debts-header">
          <i className="fa fa-credit-card"></i>
          DEBTS
        </div>
        <div style={{ overflowX: 'auto' }}>
          <table className="data-table small-table">
            <thead className="table-head">
              <tr>
                <th>Month</th>
                <th>Goal</th>
                <th>Actual</th>
                <th>Remaining</th>
                <th>Excess</th>
                <th>Rank</th>
              </tr>
            </thead>
            <tbody>
              {debtsData.map((row, index) => (
                <tr key={index} className={`table-row ${
                  row.isTotal ? 'total-row' : ''
                }`}>
                  <td className="table-cell">
                    <div className="month-cell">
                      <i className="fa fa-calendar icon-calendar"></i>
                      {row.month}
                    </div>
                  </td>
                  <td className="table-cell">{row.goal}</td>
                  <td className={`table-cell ${
                    row.highlight === 'red' ? 'red-text' : 
                    row.highlight === 'green' ? 'green-text' : ''
                  }`}>
                    {row.actual}
                  </td>
                  <td className="table-cell">{row.remaining}</td>
                  <td className="table-cell">{row.excess}</td>
                  <td className="table-cell" style={{ fontWeight: 'bold' }}>
                    {row.rank}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );

  return (
    <>
      <style>{styles}</style>
      
      <div className="annualView-bottom-dashboard-container" style={{width:"100%"}}>
        <div className="main-wrapper">
          
          {/* Tabs */}
          <div className="tabs-container">
            <TabButton 
              id="overview" 
              label="Executive Summary" 
              isActive={activeTab === 'overview'} 
              onClick={setActiveTab} 
            />
            <TabButton 
              id="monthly" 
              label="Detailed Analysis" 
              isActive={activeTab === 'monthly'} 
              onClick={setActiveTab} 
            />
          </div>

          {/* Tab Content */}
          <div className="tab-content">
            {activeTab === 'overview' && (
              <div>
                <IncomeSpendingTable />
                <ExpensesDebtsTable />
              </div>
            )}
            
            {activeTab === 'monthly' && (
              <div className="coming-soon">
                {/* <div>
                  <i className="fa fa-clock-o coming-soon-icon"></i>
                  <h3 className="coming-soon-title">Monthly Analysis Coming Soon</h3>
                  <p className="coming-soon-text">
                    Detailed monthly breakdowns and insights will be available here.
                  </p>
                </div> */}

                <BudgetSummary />
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default Bottom;